// extracted by mini-css-extract-plugin
export default {"container":"FormAddingServiceData_container__sO1gv","containerOpacity":"FormAddingServiceData_containerOpacity__7CBz+"};